<template>
  <div
    class="mwe-fonttemplate"
    :class="{
      [`position-${position}`]: Boolean(position),
    }"
    :style="{
      '--menu-max-width': menuMaxWidth,
      '--menu-max-height': menuMaxHeight || 'calc(100vh - 15px - 15px)',
    }"
  >
    <b-dropdown 
      id="dropdown-fonttemplate" 
      class="dropdown-select dropdown-select-block"
      ref="dropdown"
      variant="select"
      :boundary="boundary"
    >
      <!-- Button -->
      <template #button-content>
        {{ styleName(style) }}
        <span v-if="isCustom" class="text-danger">*</span>
      </template>

      <!-- Options -->
      <div class="dropdown-menu-inner" style="width: max-content;">
        <perfect-scrollbar ref="scrollbar" :options="{ wheelPropagation:false}">
          <b-dropdown-item
            v-for="(font, fontName) in optionFonts"
            :key="fontName"
            class="border-bottom"
            @click="style = fontName"
          >
            <div class="row -mx-0">
              <div class="col-auto px-0 pr-gd-2 align-self-center">
                <div class="border" :style="`width: 20px; height: 20px; margin: 0 auto; text-align: center; background-color: ${font.color.includes('rgba') ? font.color : $helper.color.getColor(font.color)}; border-radius: 50%;`"></div>
                <div class="fs-sa-12 text-hint">{{ font.size }}px</div>
              </div>
              <div 
                class="col px-0 align-self-center"
                :style="{
                  'font-family': `${font.family}`,
                  'font-size': `${Math.min(font.size, 40)}px`,
                  'line-height': 1,
                }"
              >
                {{ styleName(fontName) }}
              </div>
            </div>
          </b-dropdown-item>
          <div class="px-gd-2 py-gd-1">
            <span
              class="fs-sa-14 text-blue cursor-pointer"
              @click="$store.dispatch('design/component/elActive', {
                elementID: ['website_theme', 'font_style'],
              })"
            >
              {{ $t('engine.manageText.modalWidget.lblEditStyle', languageEngine) }}
            </span>
          </div>
        </perfect-scrollbar>
      </div>

    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { capitalize } from "@helpers/text.helper";

export default {
  components: {
    PerfectScrollbar,
  },
  props: {
    fontStyle: {
      // type: String,
      // default: "Select",
    },
    isCustom: {},

    position: {
      type: String,
      default: 'relative',
    },
    menuMaxWidth: {
      type: String,
      default: 'auto',
    },
    menuMaxHeight: {
      type: String,
      default: '50vh',
    },
    boundary: {
      type: String,
      default: undefined,
    },
    options: {  // ส่งมาถ้าต้องการ custom option เอง
      type: Object,
      default: undefined,
      // {
      //   "heading1": { 
      //      "color": "--tpc-22",
      //      "family": "Sarabun",
      //      "size": "16",
      //    },
      //   "paragraph1": { 
      //      "color": "--tpc-22",
      //      "family": "Sarabun",
      //      "size": "16","
      //    }
      //   "link": { 
      //      "color": "--tpc-22",
      //      "family": "Sarabun",
      //      "size": "16", }
      //    }
      // }
    },
  },
  computed: {
    ...mapGetters({
      module: "module",
    }),
    themeFonts() {
      const temp = JSON.parse(JSON.stringify(this.$store.getters[`${this.module}/metadata/templateFonts`]));
      return temp;
    },
    themeFontsLanguage() {
      const temp = JSON.parse(JSON.stringify(this.$store.getters[`${this.module}/metadata/templateFontsLanguage`]));
      return temp;
    },
    languageEngine() {
      return this.$store.getters[`${this.module}/userPreference/languageEngine`];
    },
    optionFonts() {
      let _options = {}
      if (this.options) {
        _options = this.options
      } else {
        Object.entries(this.themeFonts).forEach(([fontName, fontData]) => {
          _options[fontName] = {
            color: fontData.color,
            family: this.themeFontsLanguage[fontName].family,
            size: this.themeFontsLanguage[fontName].size,
          }
        });
      }
      return _options
    },

    // displayFontTemplate() {
    //   const template = Array.isArray(this.fontname)
    //     ? this.fontname[0]
    //     : this.fontname;
    //   return template || "Select";
    // },
    style:{
      get() {
        // return this.fontStyle;
      const template = Array.isArray(this.fontStyle)
        ? this.fontStyle[0]
        : this.fontStyle;
      return template || "Select";
      },
      set(value) {
        this.$emit("input:fontStyle", value);
        this.$emit("update:fontStyle", value);
        this.$emit("change", value);
      },
    },

    _dropdownWidth() {
      if (this.dropdownWidth.includes("%")) return this.dropdownWidth;
      return `${this.dropdownWidth}px`
    }
  },
  methods: {
    capitalize,
    styleName(name){
      return this.$t(`engine.manageText.modalWidget.style.lbl${this.capitalize(name)}`, this.languageEngine)
    },
  },
};
</script>

<style>
/* MWE Tools - FontTemplate */

/* Dropdown */
.mwe-fonttemplate .dropdown,
.mwe-area .mwe-fonttemplate .dropdown {
  line-height: 1.2;
}

/* Menu */
.mwe-fonttemplate .dropdown-select.dropdown .dropdown-menu,
.mwe-area .mwe-fonttemplate .dropdown-select.dropdown .dropdown-menu {
  min-width: auto; 
  max-width: var(--menu-max-width);
  overflow: hidden;
  border: none;
  box-shadow: 0px 16px 48px 0px rgb(0 0 0 / 18%);
  -webkit-box-shadow: 0px 16px 48px 0px rgb(0 0 0 / 18%);
}
.mwe-fonttemplate .dropdown-menu-inner,
.mwe-area .mwe-fonttemplate .dropdown-menu-inner {
  overflow: auto;
  overscroll-behavior: none;
}
.mwe-fonttemplate .dropdown-menu .ps,
.mwe-area .mwe-fonttemplate .dropdown-menu .ps {
  height: auto;
  max-height: var(--menu-max-height);
}

/* Option */
.mwe-fonttemplate .dropdown-select.dropdown .dropdown-item,
.mwe-area .mwe-fonttemplate .dropdown-select.dropdown .dropdown-item {
  height: 56px;
  padding: 8px 16px;
  /* color: #373e44;
  background-color: transparent;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important; */
}
/* 
.mwe-fonttemplate .dropdown-item.active,
.mwe-fonttemplate .dropdown-item:active {
  color: #24BEE2 !important;
}
.mwe-fonttemplate .dropdown-item:hover {
  background-color: #F4FCFF !important;
} */
</style>
